/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import {ColDef} from 'ag-grid-community';
import {dlsColor} from '@ion/dls/src/theme/theme';
import BasicGrid from '../../grid/BasicGrid';

export interface ChipsViewGridProps {
  onDelete?: (ids) => void, open?: boolean;
  disablePortal?: boolean;
  customClass?: string;
  chipValues: {id: string}[];
  columnDefs: ColDef[];
  anchorE1?: any;
  preference?: string;
};

const useStyles = makeStyles(() => ({
  suggestionsWrapper : {
    zIndex          : 5,
    top             : '-110px !important',
    transform       : 'translate3d(0px, 160px, 0px) !important',
    left            : 'unset !important',
    right           : 'unset !important',
    maxWidth        : 479,
    width           : '100%',
    height          : 'calc(100% - 75px)',
    boxShadow       : '6px 6px 10px 0px rgba(0, 0, 0, 0.10)',
    backgroundColor : dlsColor('white')
  }
}));

/**
 * The popper component in which the basic grid is integrated with provided columns and data.
 */
export const ChipsViewGrid = ({
  open,
  anchorE1,
  onDelete,
  columnDefs,
  chipValues,
  customClass,
  preference,
  disablePortal = false
}: ChipsViewGridProps) => {
  const classes = useStyles();
  return (
    <Popper disablePortal
      transition
      open={open}
      anchorEl={anchorE1}
      style={{maxWidth: 660}}
      className={classes.suggestionsWrapper}>
      <Paper style={{height: '92%'}}>
        <BasicGrid rowData={chipValues}
          disablePortal={disablePortal}
          preference={preference}
          customPaperClass={customClass}
          columnDefs={columnDefs}
          onDelete={onDelete}
          customWidth={660}/>
      </Paper>
    </Popper>
  );
};

export default ChipsViewGrid;
